export const paymentCancellationReasons: Record<string, string> = {
  "3d_secure_failed":
    "Не пройдена аутентификация по 3-D Secure. При новой попытке оплаты следует пройти аутентификацию, использовать другое платежное средство или обратиться в банк за уточнениями.",
  call_issuer:
    "Оплата данным платежным средством отклонена по неизвестным причинам. Следует обратиться в организацию, выпустившую платежное средство.",
  canceled_by_merchant: "Платеж отменен по API при оплате в две стадии.",
  card_expired:
    "Истек срок действия банковской карты. При новой попытке оплаты следует использовать другое платежное средство.",
  country_forbidden:
    "Нельзя заплатить банковской картой, выпущенной в этой стране. При новой попытке оплаты следует использовать другое платежное средство.",
  deal_expired:
    "Закончился срок жизни сделки. Если вы еще хотите принять оплату, создайте новую сделку и проведите для нее новый платеж.",
  expired_on_capture:
    "Истек срок списания оплаты у двухстадийного платежа. Если вы еще хотите принять оплату, повторите платеж с новым ключом идемпотентности и спишите деньги после подтверждения платежа пользователем.",
  expired_on_confirmation:
    "Истек срок оплаты: пользователь не подтвердил платеж. Если пользователь еще хочет оплатить, вам необходимо повторить платеж с новым ключом идемпотентности.",
  fraud_suspected:
    "Платеж заблокирован из-за подозрения в мошенничестве. При новой попытке оплаты следует использовать другое платежное средство.",
  general_decline:
    "Причина не детализирована. Следует обратиться к инициатору отмены платежа за уточнением подробностей.",
  identification_required:
    "Превышены ограничения на платежи для кошелька ЮMoney. Следует идентифицировать кошелек или выбрать другое платежное средство.",
  insufficient_funds:
    "Не хватает денег для оплаты. Следует пополнить баланс или использовать другое платежное средство.",
  internal_timeout:
    "Технические неполадки на стороне ЮKassa. Повторите платеж с новым ключом идемпотентности.",
  invalid_card_number:
    "Неправильно указан номер карты. При новой попытке оплаты следует ввести корректные данные.",
  invalid_csc:
    "Неправильно указан код CVV2 (CVC2, CID). При новой попытке оплаты следует ввести корректные данные.",
  issuer_unavailable:
    "Организация, выпустившая платежное средство, недоступна. При новой попытке оплаты следует использовать другое платежное средство или повторить оплату позже.",
  payment_method_limit_exceeded:
    "Исчерпан лимит платежей для данного платежного средства или вашего магазина. При новой попытке оплаты следует использовать другое платежное средство или повторить оплату на следующий день.",
  payment_method_restricted:
    "Запрещены операции данным платежным средством. Следует обратиться в организацию, выпустившую платежное средство.",
  permission_revoked:
    "Нельзя провести безакцептное списание: пользователь отозвал разрешение на автоплатежи. Создайте новый платеж для подтверждения оплаты пользователем.",
  unsupported_mobile_operator:
    "Нельзя заплатить с номера телефона этого мобильного оператора. При новой попытке оплаты следует использовать другое платежное средство.",
  default:
    "Произошла ошибка проведения платежа. Пожалуйста, попробуйте снова или обратитесь в поддержку.",
};
